import { IPreloadCacheContext } from 'framework/context/IPreloadCacheContext';
import { ISupplierSummary } from 'gen/ApiClient';
import React from 'react';

export const SuppliersCacheContext = React.createContext<IPreloadCacheContext<ISupplierSummary[]>>(undefined as any);
